import type { PropsWithChildren } from 'react';

import type { LearnMoreProps } from '../../learn-more';
import type { TooltipProps } from '../../tooltip';

import { cn } from '@polyseme/utils/cn/cn-utils';

import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../ui';
import { Icon } from '../../icons';
import { LearnMore } from '../../learn-more';
import { Tooltip } from '../../tooltip';

type FieldWrapperProps = PropsWithChildren & {
  className?: string;
  description?: string;
  label?: React.ReactNode;
  labelClassName?: string;
  /**
   * @deprecated Use `tooltip` instead. This prop will be removed in a future version.
   */
  learnMore?: LearnMoreProps;
  required?: boolean;
  tooltip?: Omit<TooltipProps, 'children'>;
};

export const FieldWrapper = ({
  children,
  className,
  description,
  label,
  labelClassName,
  learnMore,
  required,
  tooltip,
}: FieldWrapperProps) => {
  return (
    <FormItem className={className}>
      {!!label && <FormLabel className={labelClassName}>{label}</FormLabel>}
      {!!required && <span className="text-destructive">*</span>}
      {!!learnMore && (
        <LearnMore {...learnMore} className={cn('ml-2', learnMore.className)} />
      )}
      {!!tooltip && (
        <Tooltip {...tooltip} position={tooltip.position || 'top-left'}>
          <button
            className="ml-2 mt-auto translate-y-px text-primary"
            type="button"
          >
            <Icon className="size-4" name="info" />
          </button>
        </Tooltip>
      )}
      <FormControl>{children}</FormControl>
      {!!description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};
